import React from 'react';
import Helpers from 'utils/helpers';

export default function OptionInputWrapper(props) {
  const clonedProps = {
    ...props,
  };
  let label = props.children;

  if (Helpers.Object.exists(props.label)) {
    label = props.label;
    delete clonedProps.label;
  }

  return (
    <OptionInput {...clonedProps}>
      {label}
    </OptionInput>
  );
}

function OptionInput(props) {
  return (
    <option {...props}>
      {props.children}
    </option>
  );
}